import { render, staticRenderFns } from "./ImageUploader2.vue?vue&type=template&id=1437d18b&"
import script from "./ImageUploader2.vue?vue&type=script&lang=js&"
export * from "./ImageUploader2.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploader2.vue?vue&type=style&index=0&id=1437d18b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports